<template>
  <div class="page-form">
    <div class="page-wrap" id="demo" ref="demo">
      <div class="page-head">
        <h3>体检服务申请表</h3>
        <p>（日本）</p>
      </div>
      <i-form :label-width="100" label-position="right" class="label-font">
        <div class="page-body page-top">
          <Row :gutter="10" class="row-m">
            <i-col span="12">
              &nbsp;
            </i-col>
            <i-col span="12">
              <Form-item class="label-font item-label" label="Case#">
                <input class="flex" type="text"
                       v-model="formData.case"
                       placeholder="由威马捷填写" />
              </Form-item>
            </i-col>
          </Row>
          <Row :gutter="10" class="top-left">
            <i-col span="12">
              <Form-item label="今后联系人" style="float:left" class="i-left">
                <input
                        class="flex"
                        id="id1"
                        v-model="formData.jhlxr"
                        type="text"
                />
              </Form-item>
            </i-col>
            <i-col span="12">
              <Form-item label="与客户关系" class="item-label">
                <input
                        class="flex"
                        id="id2"
                        v-model="formData.khgx"
                        type="text"
                />
              </Form-item>
            </i-col>
          </Row>
          <Row :gutter="10" class="phone-head top-left">
            <i-col span="12">
              <Form-item label="电  话" style="float:left;" class="ogg i-left">
                <input
                        class="flex ivu-diy-input"
                        id="id3"
                        v-model="formData.dianhua"
                        type="number"
                />
              </Form-item>
            </i-col>
            <i-col span="12">
              <Form-item label="Email" class="item-label ogg">
                <input
                        class="flex"
                        id="id4"
                        v-model="formData.email"
                        type="text"
                />
              </Form-item>
            </i-col>
          </Row>
          <p class="page-note" style="margin:12px 0 40px 0;">
            <span>与今后联系人无法取得联系时，有可能与紧急联系人联系。</span>
          </p>
        </div>
        <div class="page-title">体检人信息（健診者情報）<i>*</i></div>
        <div class="page-body tjpepol" style="margin-bottom:22px;">
          <Row :gutter="10" class-name="xm" :style="{ marginTop: '30px' }">
            <i-col span="8">
              <Form-item label="姓名" class="item-forms">
                <input
                        v-model="formData.formName"
                        class="form-in-input"
                        type="text"
                        ref="xmv"
                        id="id9"
                        placeholder="汉字"
                />
              </Form-item>
            </i-col>
            <i-col span="6" class-name="khxxNameipt2">
              <input
                      v-model="formData.py"
                      class="form-in-input"
                      type="text"
                      style="width:238px;"
                      ref="py"
                      id="id10"
                      placeholder="拼音"
              />
            </i-col>
            <i-col span="10" class-name="khxxNameipt3">
              <input
                      class="form-in-input"
                      type="text"
                      style="width:100%;"
                      v-model="formData.khxxNameipt3"
                      placeholder="由威马捷填写"
              />
            </i-col>
          </Row>
          <Row :gutter="10" class-name="xb" id="id7">
            <i-col span="24" class="item-forms-2">
              <Form-item label="性别">
                <RadioGroup
                        v-model="formData.sex"
                        style="paddingTop: 3px; margin-left:-30px; font-size:14px;"
                >
                  <Radio :label="1">男性</Radio>
                  &nbsp;&nbsp;&nbsp;&nbsp;
                  <Radio :label="2" style="margin-left:13px;">女性</Radio>
                </RadioGroup>
              </Form-item>
              <Form-item>
                <i-col style="vertical-align: middle;">
                  <span
                          :style="{ fontSize: '18px', fontWeight: 'bold' }"
                          style="vertical-align: middle; margin-left:15px;"
                  >国籍</span
                  >
                  <Radio-group v-model="formData.gj1" style="margin-left:40px;">
                    <Radio :label="1">中国</Radio>
                    <Radio :label="2" style="margin-left:35px;">其它</Radio>
                  </Radio-group>
                  <input
                          type="text"
                          class="gjselect"
                          :disabled="gj1 === 1"
                          style="width: 315px; margin-left:29px;"
                          ref="gjt"
                          placeholder="请输入国籍"
                          v-model="formData.gjt"
                  />
                </i-col>
              </Form-item>
            </i-col>
          </Row>
          <Row :gutter="10">
            <i-col span="8">
              <Form-item label="出生日期">
                <DatePicker
                        type="date"
                        class="dates"
                        v-model="formData.cxrq"
                        :options="{
                    disabledDate(date) {
                      return date && date.valueOf() > Date.now();
                    },
                  }"
                        style="width: 202px"
                ></DatePicker>
              </Form-item>
            </i-col>
            <i-col span="8" class="shengao1">
              <Form-item label="身高">
                <div style="display: flex;">
                  <input
                          type="text"
                          ref="sg"
                          placeholder="cm"
                          v-model="formData.sg"
                  />cm
                </div>
              </Form-item>
            </i-col>
            <i-col span="8" class="shengao1">
              <Form-item label="体重" style="padding-left: 0px;">
                <div style="display: flex;">
                  <input
                          type="text"
                          ref="tz"
                          placeholder="kg"
                          v-model="formData.tz"
                  />kg
                </div>
              </Form-item>
            </i-col>
          </Row>
          <Row :gutter="10">
            <i-col span="24" style="float: left;" class="phone-email">
              <Form-item label="电话号码">
                <input
                        type="number"
                        style="width:343px;"
                        ref="dhhm"
                        class="flex ivu-diy-input"
                        v-model="formData.dhhm"
                />
              </Form-item>
              <Form-item label="E-mail" style="float: left;" class="email">
                <input
                        type="text"
                        v-model="formData.email2"
                        style="width:344px"
                        id="id5"
                        ref="emailt"
                        class="flex"
                />
              </Form-item>
            </i-col>
          </Row>
          <Row :gutter="10">
            <i-col span="24" class="jzd">
              <Form-item label="现居住地地址" class="labels">
                <input
                        type="text"
                        style="width:456px;"
                        ref="xjzd"
                        class="flex"
                        v-model="formData.xjdz"
                />
              </Form-item>
              <Form-item label="邮编" class="yb">
                <input
                        type="number"
                        style="width:212px;"
                        ref="ybx"
                        class="flex ivu-diy-input"
                        v-model="formData.ybx"
                />
              </Form-item>
            </i-col>
          </Row>
          <Row :gutter="10">
            <i-col span="24" class="zlyj">
              <Form-item
                      label="资料邮寄地址"
                      placeholder="详细填写到门牌号码"
                      class="labels"
              >
                <input
                        type="text"
                        style="width:456px;"
                        ref="zlyjdz"
                        class="flex"
                        v-model="formData.zlyjdz"
                />
              </Form-item>
              <Form-item label="邮编" class="yb">
                <input
                        type="number"
                        style="width:212px;"
                        ref="ybz"
                        class="flex ivu-diy-input"
                        v-model="formData.ybz"
                />
              </Form-item>
            </i-col>
          </Row>
          <Row :gutter="10">
            <i-col span="24" class="phone-email">
              <Form-item label="收件人" style="float: left;">
                <input
                        type="text"
                        style="width:343px;"
                        ref="sjr"
                        class="flex"
                        placeholder="收件人"
                        v-model="formData.sjr"
                />
              </Form-item>
              <Form-item label="电话" style="float: left;" class="email">
                <input
                        type="number"
                        style="width:344px"
                        ref="sjrdh"
                        class="flex ivu-diy-input"
                        placeholder="电话"
                        v-model="formData.sjrdh"
                />
              </Form-item>
            </i-col>
          </Row>
          <!--<Row :gutter="10"-->
          <!--class-name="sjr">-->
          <!--<i-col span="24" style="display: flex;">-->
          <!--<Form-item label="收件人">-->
          <!--<input type="text"-->
          <!--style="width:332px;"-->
          <!--class="flex"-->
          <!--ref="sjr"-->
          <!--placeholder="收件人" />-->
          <!--</Form-item>-->
          <!--<Form-item label="电话" style="padding-left: 15px;">-->
          <!--<input type="text"-->
          <!--style="width:368px;margin-left: -15px;"-->
          <!--class="flex"-->
          <!--ref="sjrdh"-->
          <!--placeholder="电话" />-->
          <!--</Form-item>-->
          <!--</i-col>-->
          <!--</Row>-->
          <Row :gutter="10" class-name="mybox">
            <i-col span="24" class="my">
              <Form-item label="母语">
                <RadioGroup v-model="formData.country">
                  <Radio :label="1" style="font-size:14px;">中文</Radio>
                  <Radio :label="2" style="margin-left:0px; font-size:14px;"
                  >其它</Radio
                  >
                </RadioGroup>
                <input
                        type="text"
                        :disabled="country === 1"
                        style="width:185px"
                        ref="myt"
                        placeholder="请输入母语"
                />
              </Form-item>
            </i-col>
          </Row>
        </div>
        <div class="page-title">
          体检套餐（健診プラン）
          <i>*</i>
          <span style="margin-left: 200px;">任选项目（オプション）</span>
        </div>
        <div class="page-body">
          <!-- 套餐选择 -->
          <div class="page-menu" id="id9">
            <div class="page-submenu">
              <ul>
                <li
                        class="pageMenu-li"
                        v-for="(item, index) in formHtmlOfSet"
                        :key="index"
                >
                  <input
                          type="radio"
                          name="setMeal"
                          :checked="index === 0"
                          @change="change(index, item.id)"
                          :style="{ width: '16px', height: '16px' }"
                  />
                  <span class="pageMenu-span">{{ item.name }}</span>
                </li>
              </ul>
            </div>
            <div class="porject-box">
              <ul>
                <li
                        class="pageMenu-li"
                        v-for="(item, index) in formHtmlOfPro"
                        :key="index"
                >
                  <input
                          type="checkbox"
                          name="porjectName"
                          :value="item.id"
                          v-model="tjxm"
                          :style="{ width: '16px', height: '16px' }"
                  />
                  <span class="pageMenu-span">{{ item.name }}</span>
                </li>
              </ul>
            </div>
          </div>
          <h4 class="page-stitle">希望体检日期（健診希望日）</h4>
          <p class="page-note" style="font-size:14px;">
            请避开周六、周日、日本节假日
            <span class="page-note" style="margin-left:30px;"
            >名额已满时，另调整</span
            >
          </p>
          <div class="page-hope bt">
            <Row :gutter="10">
              <i-col span="6" id="id11">
                <DatePicker
                        format="yyyy-MM-dd"
                        :options="{
                    disabledDate(date) {
                      return date && date.valueOf() < Date.now() - 86400000;
                    },
                  }"
                        v-model="formData.xwtj1"
                        type="date"
                        placeholder="Select date"
                        style="width: 200px"
                        @on-change="xwtj1 = $event"
                ></DatePicker>
              </i-col>
              <i-col span="6">
                <DatePicker
                        v-model="formData.xwtj2"
                        :options="{
                    disabledDate(date) {
                      return date && date.valueOf() < Date.now() - 86400000;
                    },
                  }"
                        format="yyyy-MM-dd"
                        type="date"
                        placeholder="Select date"
                        style="width: 200px"
                        @on-change="xwtj2 = $event"
                ></DatePicker>
              </i-col>
              <i-col span="6">
                <DatePicker
                        v-model="formData.xwtj3"
                        :options="{
                    disabledDate(date) {
                      return date && date.valueOf() < Date.now() - 86400000;
                    },
                  }"
                        format="yyyy-MM-dd"
                        type="date"
                        placeholder="Select date"
                        style="width: 200px"
                        @on-change="xwtj3 = $event"
                ></DatePicker>
              </i-col>
              <i-col span="6" style="margin-top:6px;"> </i-col>
            </Row>
          </div>
          <h4 class="page-stitle" style="margin:30px 0;">
            既往病史(既往歴)<i :style="{ color: 'red' }">*</i>
          </h4>
          <Row :gutter="10">
            <i-col span="5">
              <label class="label-with-radio no-label">
                <input
                        type="radio"
                        ref="jwbsW"
                        id="id12"
                        @change="jwbsWChange(1)"
                        name="jwbs"
                        value="0"
                        v-model="formData.jwbsY"
                />无（無）
              </label>
            </i-col>
          </Row>
          <Row :gutter="10">
            <i-col span="2">
              <label class="label-with-radio">
                <input
                        type="radio"
                        ref="jwbsY"
                        @change="jwbsWChange(2)"
                        name="jwbs"
                        value="1"
                        v-model="formData.jwbsY"
                />有
              </label>
            </i-col>
            <i-col span="22">
              <Row class-name="qt">
                <i-col span="24">
                  <label class="label-with-radio" style="margin-right:47px;">
                    <input
                            type="checkbox"
                            :disabled="jwbs_b === 1"
                            ref="jwbsC1"
                            name="check1"
                            v-model="formData.jwbsC1"
                    />&nbsp;&nbsp;肺结核（含肺部阴影）（肺結核胸部陰影含む)
                  </label>
                  <label class="label-with-radio" style="margin-right:52px;">
                    <input
                            type="checkbox"
                            :disabled="jwbs_b === 1"
                            ref="jwbsC2"
                            name="check1"
                            v-model="formData.jwbsC2"
                    />&nbsp;&nbsp;糖尿病（糖尿病）
                  </label>
                  <label class="label-with-radio">
                    <input
                            type="checkbox"
                            :disabled="jwbs_b === 1"
                            ref="jwbsC3"
                            name="check1"
                            v-model="formData.jwbsC3"
                    />&nbsp;&nbsp;肾功能障碍（腎機能障害）
                  </label>
                </i-col>
                <i-col span="24">
                  <label class="label-with-radio" style="margin-right:30px;">
                    <input
                            type="checkbox"
                            ref="jwbsC4"
                            :disabled="jwbs_b === 1"
                            name="check1"
                            v-model="formData.jwbsC4"
                    />&nbsp;&nbsp;高血压（高血圧）
                  </label>
                  <label class="label-with-radio">
                    <input
                            type="checkbox"
                            :disabled="jwbs_b === 1"
                            name="check1"
                            v-model="formData.jwbsC7"
                    />&nbsp;&nbsp;支气管哮喘（気管支喘息）
                  </label>
                  <label class="label-with-radio">
                    <input
                            type="checkbox"
                            ref="jwbsC5"
                            :disabled="jwbs_b === 1"
                            name="check1"
                            v-model="formData.jwbsC5"
                    />&nbsp;&nbsp;心脏病（心臓病）
                  </label>
                </i-col>
                <i-col span="24">
                  <label :style="{ margin: '0 10px' }">
                    <input
                            type="checkbox"
                            ref="jwbsC6"
                            :disabled="jwbs_b === 1"
                            value="7"
                            name="check1"
                            v-model="formData.jwbsC6"
                    />&nbsp;&nbsp;其它
                    <input
                            type="text"
                            ref="jwbsCt"
                            :disabled="jwbs_b === 1"
                            class="form-in-input"
                            :style="{ width: '90%' }"
                            style="margin-left:10px;margin-top: 10px;"
                            placeholder="请说明"
                            v-model="formData.jwbsCt"
                    />
                  </label>
                </i-col>
              </Row>
            </i-col>
          </Row>
          <h4 class="page-stitle">
            过敏史（アレルギー）<i :style="{ color: 'red' }">*</i>
          </h4>
          <Row :gutter="10">
            <i-col span="5">
              <label class="label-with-radio no-label">
                <input
                        type="radio"
                        ref="gmsW"
                        id="id13"
                        @change="gmsWChange(1)"
                        name="gms"
                        value="0"
                        v-model="formData.gmsY"
                />无（無）
              </label>
            </i-col>
          </Row>
          <Row :gutter="10" class="bt qt">
            <i-col span="2">
              <label class="label-with-radio">
                <input
                        type="radio"
                        ref="gmsY"
                        @change="gmsWChange(2)"
                        name="gms"
                        value="1"
                        v-model="formData.gmsY"
                />有
              </label>
            </i-col>
            <i-col span="22">
              <Row :gutter="10">
                <i-col span="8">
                  <label class="label-with-radio">
                    <input
                            type="checkbox"
                            :disabled="gms === 1"
                            ref="gmsC1"
                            name="gmsCheck"
                            v-model="formData.gmsC1"
                    />&nbsp;&nbsp;碘（ヨード）
                  </label>
                </i-col>
                <i-col span="8">
                  <label class="label-with-radio">
                    <input
                            type="checkbox"
                            ref="gmsC2"
                            :disabled="gms === 1"
                            name="gmsCheck"
                            v-model="formData.gmsC2"
                    />&nbsp;&nbsp;造影剂（造影剤）
                  </label>
                </i-col>
                <i-col span="24" style="margin-top:18px;">
                  <label :style="{ margin: '0 10px' }">
                    <input
                            type="checkbox"
                            ref="gmsC3"
                            :disabled="gms === 1"
                            name="gmsCheck"
                            v-model="formData.gmsC3"
                    />&nbsp;&nbsp;其它
                    <input
                            type="text"
                            class="form-in-input"
                            :style="{ width: '90%' }"
                            style="margin-left:10px;margin-top: 10px;"
                            :disabled="gms === 1"
                            ref="gmsCt"
                            placeholder="请注明"
                            v-model="formData.gmsCt"
                    />
                  </label>
                </i-col>
              </Row>
            </i-col>
          </Row>
          <h4 class="page-stitle">
            体内有无金属（体内金属の有無）<i :style="{ color: 'red' }">*</i>
          </h4>
          <Row :gutter="10" class-name="qt">
            <i-col span="5">
              <label class="label-with-radio no-label">
                <input
                        type="radio"
                        ref="tnjsW"
                        id="id14"
                        value="0"
                        @change="tnjsWChange(1)"
                        name="tnjs"
                        v-model="formData.tnjsY"
                />无（無）
              </label>
            </i-col>
          </Row>
          <Row :gutter="10" class="bt">
            <i-col span="2">
              <label class="label-with-radio">
                <input
                        type="radio"
                        ref="tnjsY"
                        @change="tnjsWChange(2)"
                        name="tnjs"
                        value="1"
                        v-model="formData.tnjsY"
                />有
              </label>
            </i-col>
            <i-col span="22">
              <Row class-name="qt">
                <i-col span="24">
                  <label class="label-with-radio" style="margin-right:50px">
                    <input
                            type="checkbox"
                            ref="tnjsC1"
                            :disabled="tnjs === 1"
                            name="tnjsCheck"
                            v-model="formData.tnjsC1"
                    />&nbsp;&nbsp;避孕环（避妊リング）
                  </label>
                  <label class="label-with-radio" style="margin-right:50px">
                    <input
                            type="checkbox"
                            ref="tnjsC2"
                            :disabled="tnjs === 1"
                            name="tnjsCheck"
                            v-model="formData.tnjsC2"
                    />&nbsp;&nbsp;假牙、种牙（義歯、インプラント）
                  </label>
                  <label class="label-with-radio">
                    <input
                            type="checkbox"
                            ref="tnjsC3"
                            :disabled="tnjs === 1"
                            name="tnjsCheck"
                            v-model="formData.tnjsC3"
                    />&nbsp;&nbsp;纹身（タトゥー）
                  </label>
                </i-col>

                <i-col span="24">
                  <label class="label-with-radio">
                    <input
                            type="checkbox"
                            ref="tnjsC4"
                            :disabled="tnjs === 1"
                            name="tnjsCheck"
                            v-model="formData.tnjsC4"
                    />&nbsp;&nbsp;心脏起搏器（心臓ペースメーカー）
                  </label>
                </i-col>
                <i-col span="24">
                  <label :style="{ margin: '0 10px' }">
                    <input
                            type="checkbox"
                            ref="tnjsC5"
                            :disabled="tnjs === 1"
                            name="tnjsCheck"
                            v-model="formData.tnjsC5"
                    />&nbsp;&nbsp;其它
                    <input
                            type="text"
                            class="form-in-input"
                            style="margin-left: 8px;margin-top: 10px;"
                            :style="{ width: '90%' }"
                            ref="tnjsCt"
                            :disabled="tnjs === 1"
                            placeholder="请说明"
                            v-model="formData.tnjsCt"
                    />
                  </label>
                </i-col>
              </Row>
            </i-col>
          </Row>
          <h4 class="page-stitle">
            现有的症状（現在お困りの症状）<i :style="{ color: 'red' }">*</i>
          </h4>
          <Row :gutter="10">
            <i-col span="5">
              <label class="label-with-radio no-label">
                <input
                        type="radio"
                        ref="xyzzW"
                        id="id15"
                        @change="xyzzWChange(1)"
                        name="info4"
                        value="0"
                        v-model="formData.xyzzY"
                />无（無）
              </label>
            </i-col>
          </Row>
          <Row :gutter="10" class="bt yes-label qt">
            <i-col span="2">
              <label class="label-with-radio">
                <input
                        type="radio"
                        ref="xyzzY"
                        value="1"
                        @change="xyzzWChange(2)"
                        name="info4"
                        v-model="formData.xyzzY"
                />有
              </label>
            </i-col>
            <i-col span="22">
              <label class="label-with-radio">
                <input
                        type="text"
                        class="form-in-input"
                        style="margin-top: -8px;"
                        :disabled="xyzz === 1"
                        placeholder="具体情况"
                        ref="xyzzT"
                        :style="{ width: '801px' }"
                        v-model="formData.xyzzT"
                />
              </label>
            </i-col>
          </Row>
          <h4 class="page-stitle">
            现服用的药物（現在服用中の薬）<i :style="{ color: 'red' }">*</i>
          </h4>
          <Row :gutter="10">
            <i-col span="5">
              <label class="label-with-radio no-label">
                <input
                        type="radio"
                        ref="xfyywW"
                        id="id16"
                        value="0"
                        @change="xfyywWChange(1)"
                        name="xfyyw"
                        v-model="formData.xfyywY"
                />无（無）
              </label>
            </i-col>
          </Row>
          <Row
                  :gutter="10"
                  :style="{ marginBottom: sex === 2 ? '0px' : '30px' }"
                  class="bt yes-label"
          >
            <i-col span="2">
              <label class="label-with-radio">
                <input
                        type="radio"
                        ref="xfyywY"
                        @change="xfyywWChange(2)"
                        name="xfyyw"
                        value="1"
                        v-model="formData.xfyywY"
                />有
              </label>
            </i-col>
            <i-col span="22">
              <label class="label-with-radio">
                <input
                        type="text"
                        class="form-in-input"
                        style="margin-top: -8px;"
                        :disabled="xfyy === 1"
                        placeholder="具体情况"
                        ref="xfyywT"
                        :style="{ width: '801px' }"
                        v-model="formData.xfyywT"
                />
              </label>
            </i-col>
          </Row>
          <Row class="bt">
            <i-col span="12" style="margin-bottom:20px;">
              <h4 class="page-stitle">
                （限女性）怀孕的可能性（妊娠の可能性）<i :style="{ color: 'red' }">*</i>
              </h4>
              <Row :gutter="10">
                <i-col span="8">
                  <label class="label-with-radio">
                    <input
                            type="radio"
                            id="id17"
                            :disabled="sex === 1"
                            ref="hyknY"
                            value="1"
                            name="info6"
                            v-model="formData.hyknY"
                    />有
                  </label>
                </i-col>
                <i-col span="8">
                  <label class="label-with-radio">
                    <input
                            type="radio"
                            ref="hyknW"
                            value="0"
                            :disabled="sex === 1"
                            name="info6"
                            v-model="formData.hyknY"
                    />无（無）
                  </label>
                </i-col>
              </Row>
            </i-col>
            <i-col span="12">
              <h4 class="page-stitle">
                （限女性）是否月经期（生理中）<i :style="{ color: 'red' }">*</i>
              </h4>
              <Row :gutter="10">
                <i-col span="8">
                  <label class="label-with-radio">
                    <input
                            type="radio"
                            ref="yjqY"
                            :disabled="sex === 1"
                            name="info7"
                            value="1"
                            v-model="formData.yjqY"
                    />是
                  </label>
                </i-col>
                <i-col span="8">
                  <label class="label-with-radio">
                    <input
                            type="radio"
                            ref="yjqW"
                            id="id17"
                            value="0"
                            :disabled="sex === 1"
                            name="info7"
                            v-model="formData.yjqY"
                    />不是
                  </label>
                </i-col>
              </Row>
            </i-col>
          </Row>
        </div>
        <div class="page-title" style="margin-bottom:20px;">
          您是如何联系到我公司的？
          <i>*</i>
        </div>
        <div class="page-body LXcompany">
          <Row :gutter="10" class-name="LXradio">
            <i-col span="4">
              <label class="label-with-radio-1">
                <input
                        type="checkbox"
                        ref="lxgs1"
                        id="id18"
                        name="info8"
                        v-model="formData.lxgs1"
                />病友介绍
              </label>
            </i-col>
            <i-col span="4">
              <label class="label-with-radio-1">
                <input
                        type="checkbox"
                        ref="lxgs2"
                        name="info8"
                        v-model="formData.lxgs2"
                />朋友介绍
              </label>
            </i-col>
            <i-col span="4">
              <label class="label-with-radio-1">
                <input
                        type="checkbox"
                        ref="lxgs3"
                        name="info8"
                        v-model="formData.lxgs3"
                />EAJ网站
              </label>
            </i-col>
            <i-col span="4">
              <label class="label-with-radio-1">
                <input
                        type="checkbox"
                        ref="lxgs4"
                        name="info8"
                        v-model="formData.lxgs4"
                />MAJ网站
              </label>
            </i-col>
            <i-col span="5">
              <label class="label-with-radio-1">
                <input
                        type="checkbox"
                        ref="lxgs5"
                        name="info8"
                        v-model="formData.lxgs5"
                />威马捷中文网站
              </label>
            </i-col>
            <i-col span="4">
              <label class="label-with-radio-1">
                <input
                        type="checkbox"
                        ref="lxgs6"
                        name="info8"
                        v-model="formData.lxgs6"
                />外务省网站
              </label>
            </i-col>
            <i-col span="8">
              <label class="label-with-radio-1" style="display: flex;">
                <input
                        type="checkbox"
                        ref="lxgs7"
                        name="info8"
                        v-model="formData.lxgs7"
                />医院介绍 <i style="color: red">*</i>&nbsp;&nbsp;
                <input
                        class="form-in-input"
                        type="text"
                        ref="lxgs7t"
                        style="width:55%;"
                        v-model="formData.lxgs7t"
                />
              </label>
            </i-col>
            <i-col span="8">
              <label class="label-with-radio-1" style="display: flex;">
                <input
                        type="checkbox"
                        name="info8"
                        ref="lxgs8"
                        class="radio-size radio-sizeF"
                        v-model="formData.lxgs8"
                />医院网站 <i style="color: red">*</i>&nbsp;&nbsp;
                <input
                        class="form-in-input"
                        type="text"
                        ref="lxgs8t"
                        style="width:55%;"
                        v-model="formData.lxgs8t"
                />
              </label>
            </i-col>
            <i-col span="8">
              <label class="label-with-radio-1" style="display: flex;">
                <input
                        type="checkbox"
                        name="info8"
                        ref="lxgs9"
                        class="radio-size radio-sizeF"
                        v-model="formData.lxgs9"
                />其它 <i style="color: red">*</i>&nbsp;&nbsp;
                <input
                        class="form-in-input"
                        type="text"
                        ref="lxgs9t"
                        style="width:55%;"
                        v-model="formData.lxgs9t"
                />
              </label>
            </i-col>
          </Row>
          <!--<Row :gutter="10" class-name="LXradio">-->
            <!--<i-col span="8">-->
              <!--<label class="label-with-radio-1">-->
                <!--<input-->
                        <!--type="checkbox"-->
                        <!--ref="lxgs7"-->
                        <!--name="info8"-->
                        <!--v-model="formData.lxgs7"-->
                <!--/>医院介绍 <i style="color: red">*</i>&nbsp;&nbsp;-->
                <!--<input-->
                        <!--class="form-in-input"-->
                        <!--type="text"-->
                        <!--ref="lxgs7t"-->
                        <!--style="width:65%;"-->
                        <!--v-model="formData.lxgs7t"-->
                <!--/>-->
              <!--</label>-->
            <!--</i-col>-->
            <!--<i-col span="8">-->
              <!--<label class="label-with-radio-1">-->
                <!--<input-->
                        <!--type="checkbox"-->
                        <!--name="info8"-->
                        <!--ref="lxgs8"-->
                        <!--class="radio-size radio-sizeF"-->
                        <!--v-model="formData.lxgs8"-->
                <!--/>医院网站 <i style="color: red">*</i>&nbsp;&nbsp;-->
                <!--<input-->
                        <!--class="form-in-input"-->
                        <!--type="text"-->
                        <!--ref="lxgs8t"-->
                        <!--style="width:65%;"-->
                        <!--v-model="formData.lxgs8t"-->
                <!--/>-->
              <!--</label>-->
            <!--</i-col>-->
            <!--<i-col span="8">-->
              <!--<label class="label-with-radio-1">-->
                <!--<input-->
                        <!--type="checkbox"-->
                        <!--name="info8"-->
                        <!--ref="lxgs9"-->
                        <!--class="radio-size radio-sizeF"-->
                        <!--v-model="formData.lxgs9"-->
                <!--/>其它 <i style="color: red">*</i>&nbsp;&nbsp;-->
                <!--<input-->
                        <!--class="form-in-input"-->
                        <!--type="text"-->
                        <!--ref="lxgs9t"-->
                        <!--style="width:60%;"-->
                        <!--v-model="formData.lxgs9t"-->
                <!--/>-->
              <!--</label>-->
            <!--</i-col>-->
          <!--</Row>-->
        </div>
        <div class="page-title">今后联系人为客户本人时，请指定紧急联系人</div>
        <div class="page-body">
          <Row :gutter="10">
            <i-col span="12">
              <Form-item label="紧急联系人" class="mail">
                <input
                        class="flex"
                        style="margin-left:15px; width:328px"
                        type="text"
                        v-model="formData.jjlxr"
                />
              </Form-item>
            </i-col>
            <i-col span="12" class="ms">
              <Form-item label="与客户关系">
                <input class="flex"
                       style="margin-left:15px; width:328px"
                       type="text"
                       v-model="formData.ykhgx"
                />
              </Form-item>
            </i-col>
            <i-col span="12" class="dh">
              <Form-item label="电  话" style="margin-bottom:0px !important">
                <input
                        class="flex"
                        style="margin-left:15px; width:328px"
                        type="text"
                        v-model="formData.khdh"
                />
              </Form-item>
            </i-col>
            <i-col span="12">
              <Form-item
                      label="E-mail"
                      class="ms"
                      style="margin-bottom:0px !important"
              >
                <input
                        class="flex"
                        v-model="formData.email3"
                        id="id6"
                        style="margin-left:15px; width:328px"
                        type="text"
                />
              </Form-item>
            </i-col>
          </Row>
          <div class="page-border">
            <p class="page-note" style="margin-bottom:10px;margin-top:10px;">
              <span
              >与今后联系人无法取得联系时，有可能与客户本人直接联系。</span
              >
            </p>
          </div>
        </div>
        <div class="page-body">
          <div>
            <p
                    class="page-note"
                    style="margin-bottom:0px;margin-top:18px; font-size:14px; line-height:14px;"
            >
              <span
              >请详细填写上述全部内容，如没有详细填写，我公司有可能无法接受您的申请。</span
              >
            </p>
            <p
                    class="page-note"
                    style="margin-top:0; font-size:14px; margin-bottom:11px; line-height:14px;"
            >
              <span
              >填写的所有内容必须保证全部属实，如有虚假内容后果自负，本公司不承担任何责任。</span
              >
            </p>
          </div>
          <div>
            <p class="page-note" style="margin-bottom:0; font-size:14px;">
              <span>注意事项及免责声明</span>
            </p>
            <p class="page-state" style="color: #858585;">
              1.
              曾经有过纹身（包括纹眉）即使目前已清除，也有可能无法接受MRI检查，详情请咨询。
            </p>
            <p class="page-state" style="color: #858585;">
              2.
              因未如实填写信息，因医学原因当天被取消部分或全部检查的，不予退款。
            </p>
            <p class="page-state" style="color: #858585;">
              3.
              患有传染病（包括肺结核、疑似肺结核、流感等）的客人，无法进行体检。如体检时发现疑似肺结核等传染病，立即终止体检，体检费用不予退还。
            </p>
            <p class="page-state" style="color: #858585;">
              4. 医生有可能根据体检人的身体情况，不允许使用镇静剂。
            </p>
            <p class="page-state" style="color: #858585;">
              5.
              本公司也不会对医疗机构的医疗失误及代叫的交通机关的事故等负任何责任。
            </p>
            <p class="page-state" style="margin-bottom:30px;color: #858585;">
              6.
              本项服务有可能由于天灾及战争等无法抗拒的灾难而无法提供或有部分服务接受限制。
            </p>
          </div>
        </div>
      </i-form>
    </div>
    <div class="text-center">
      <button class="btn" @click="submit">提交</button>
    </div>
  </div>
</template>
<script>
  import * as apis from "@/api/other";
  import $ from "jquery";
  import {
    verifyPhone,
    verifyEmail,
    verifyPassword,
  } from "../../public/js/util.js";
  export default {
    data() {
      return {
        username: "",
        form: {
          one: "",
        },
        id: 0,
        type: "",
        formHtmlOfSet: [],
        formHtmlOfPro: [],
        formName: "",
        formPY: "",
        sex: "",
        selectSetMealVal: 0,
        selectSetProVal: [],

        gj1: "",
        gjt: "",
        cxrq: "",
        sg: "",
        tz: "",
        country: "",
        myt: "",
        xwtj1: "",
        xwtj2: "",
        xwtj3: "",
        jwbsW: "",
        jwbsY: "",
        jwbsC1: "",
        jwbsC2: "",
        jwbsC3: "",
        jwbsC4: "",
        jwbsC5: "",
        jwbsC6: "",
        jwbsCt: "",
        gmsW: "",
        gmsY: "",
        gmsC1: "",
        gmsC2: "",
        gmsC3: "",
        gmsCt: "",
        tnjsW: "",
        tnjsY: "",
        tnjsC1: "",
        tnjsC2: "",
        tnjsC3: "",
        tnjsC4: "",
        tnjsC5: "",
        tnjsCt: "",
        xyzzW: "",
        xyzzY: "",
        xyzzT: "",
        xfyywW: "",
        xfyywY: "",
        xfyywT: "",
        hyknW: "",
        hyknY: "",
        yjqY: "",
        yjqW: "",
        xmv: "",
        py: "",
        dhhm: "",
        emailt: "",
        xjzd: "",
        ybx: "",
        zlyjdz: "",
        ybz: "",
        sjr: "",
        sjrdh: "",
        lxgs1: "",
        lxgs2: "",
        lxgs3: "",
        lxgs4: "",
        lxgs5: "",
        lxgs6: "",
        lxgs7: "",
        lxgs8: "",
        lxgs9: "",
        lxgs7t: "",
        lxgs8t: "",
        lxgs9t: "",
        jwbs_b: "",
        jhlxr: "",
        khgx: "",
        dianhua: "",
        email: "",
        gms: "",
        tnjs: "",
        xyzz: "",
        xfyy: "",
        email2: "",
        email3: "",
        formData: {
          selectSetMealVal: 0,
          selectSetProVal: [],
        },
        tjxm: [],
        tjid: null
      };
    },
    mounted() {
      let id = this.$route.params.hid;
      this.id = id;
      this.getFormTable(id);
      this.type = localStorage.getItem("hospital_type");
      //   this.getFormStep();

      let that = this;
      $("input[name='check1']").on("change", function() {
        that.$refs.jwbsY.checked = true;
      });
      $("input[name='gmsCheck']").on("change", function() {
        that.$refs.gmsY.checked = true;
      });
      $("input[name='tnjsCheck']").on("change", function() {
        that.$refs.tnjsY.checked = true;
      });
    },
    methods: {
      jwbsWChange(index) {
        this.jwbs_b = index;
        if (index === 1) {
          $("input[name='check1']").prop("checked", false);
          if (this.$refs.jwbsCt) {
            this.$refs.jwbsCt.value = "";
          }
        }
      },
      gmsWChange(index) {
        if (index === 1) {
          $("input[name='gmsCheck']").prop("checked", false);
          if (this.$refs.gmsCt) {
            this.$refs.gmsCt.value = "";
          }
        }
        this.gms = index;
      },
      tnjsWChange(index) {
        if (index === 1) {
          $("input[name='tnjsCheck']").prop("checked", false);
          if (this.$refs.tnjsCt) {
            this.$refs.tnjsCt.value = "";
          }
        }
        this.tnjs = index;
      },
      xyzzWChange(index) {
        if (index === 1) {
          if (this.$refs.xyzzT) {
            this.$refs.xyzzT.value = "";
          }
        }
        this.xyzz = index;
      },
      xfyywWChange(index) {
        if (index !== 1) {
          if (this.$refs.xfyywT) {
            this.$refs.xfyywT.value = "";
            this.$refs.xfyywT.value = "";
          }
        }
        this.xfyy = index;
      },
      async getFormTable(id) {
        try {
          let data = {
            id,
          };
          let res = await apis.getFormTablePart(data);
          if (res.code == 200) {
            this.formHtmlOfSet = res.data.plan;
            this.formHtmlOfPro = this.formHtmlOfSet[
              this.selectSetMealVal
              ].project;
            this.tjid = this.formHtmlOfSet[this.selectSetMealVal].id
          }
        } catch (e) {
          console.log(e);
        }
      },
      change(index, id) {
        this.selectSetMealVal = index;
        this.tjid = id;
        this.tjxm = [];
      },
      dateFormat(fmt, date) {
        let ret;
        const opt = {
          "Y+": date.getFullYear().toString(), // 年
          "m+": (date.getMonth() + 1).toString(), // 月
          "d+": date.getDate().toString(), // 日
          "H+": date.getHours().toString(), // 时
          "M+": date.getMinutes().toString(), // 分
          "S+": date.getSeconds().toString(), // 秒
        };
        for (let k in opt) {
          ret = new RegExp("(" + k + ")").exec(fmt);
          if (ret) {
            fmt = fmt.replace(
              ret[1],
              ret[1].length == 1 ? opt[k] : opt[k].padStart(ret[1].length, "0")
            );
          }
        }
        return fmt;
      },
      os() {
        var regex_match = /(nokia|iphone|android|motorola|^mot-|softbank|foma|docomo|kddi|up.browser|up.link|htc|dopod|blazer|netfront|helio|hosin|huawei|novarra|CoolPad|webos|techfaith|palmsource|blackberry|alcatel|amoi|ktouch|nexian|samsung|^sam-|s[cg]h|^lge|ericsson|philips|sagem|wellcom|bunjalloo|maui|symbian|smartphone|midp|wap|phone|windows ce|iemobile|^spice|^bird|^zte-|longcos|pantech|gionee|^sie-|portalmmm|jigs browser|hiptop|^benq|haier|^lct|operas*mobi|opera*mini|320x320|240x320|176x220)/i;
        var u = navigator.userAgent;
        if (null == u) {
          return true;
        }
        var result = regex_match.exec(u);

        if (null == result) {
          return false
        } else {
          return true
        }
      },
      async submit() {
        let arr = [];
        let arr2 = [];
        if (!this.formData.jhlxr) {
          setTimeout(() => {
            this.$message({
              showClose: true,
              message: "请输入今后联系人",

              duration: 5000,
            });
          }, 0);
          arr.push(false);
          arr2.push("id1");
        }
        if (!this.formData.khgx) {
          setTimeout(() => {
            this.$message({
              showClose: true,
              message: "请输入与客户关系",

              duration: 5000,
            });
          }, 0);
          arr2.push("id2");
          arr.push(false);
        }
        if (!this.formData.dianhua) {
          setTimeout(() => {
            this.$message({
              showClose: true,
              message: "请输入电话",

              duration: 5000,
            });
          }, 0);
          arr2.push("id3");
          arr.push(false);
        }
        if (this.formData.email && !verifyEmail(this.formData.email)) {
          setTimeout(() => {
            this.$message({
              showClose: true,
              message: "邮箱格式不正确！",

              duration: 5000,
            });
          }, 0);
          arr2.push("id4");
          arr.push(false);
        }
        if (!this.formData.email) {
          setTimeout(() => {
            this.$message({
              showClose: true,
              message: "请输入邮箱！",

              duration: 5000,
            });
          }, 0);
          arr2.push("id4");
          arr.push(false);
        }

        if (this.formData.email2 && !verifyEmail(this.formData.email2)) {
          setTimeout(() => {
            this.$message({
              showClose: true,
              message: "邮箱格式不正确！",

              duration: 5000,
            });
          }, 0);
          arr2.push("id5");
          arr.push(false);
        }
        if (!this.formData.email2) {
          setTimeout(() => {
            this.$message({
              showClose: true,
              message: "请输入邮箱！",

              duration: 5000,
            });
          }, 0);
          arr2.push("id5");
          arr.push(false);
        }
        if (this.formData.email3 && !verifyEmail(this.formData.email3)) {
          setTimeout(() => {
            this.$message({
              showClose: true,
              message: "邮箱格式不正确！",

              duration: 5000,
            });
          }, 0);
          arr2.push("id6");
          arr.push(false);
        }
        if (!this.formData.sex) {
          setTimeout(() => {
            this.$message({
              showClose: true,
              message: "性别未选择",

              duration: 5000,
            });
          }, 0);
          arr2.push("id7");
          arr.push(false);
        }
        if (!this.formData.formName) {
          setTimeout(() => {
            this.$message({
              showClose: true,
              message: "请输入姓名",

              duration: 5000,
            });
          }, 0);
          arr2.push("id9");
          arr.push(false);
        }
        if (!this.$refs.py.value) {
          setTimeout(() => {
            this.$message({
              showClose: true,
              message: "请输入姓名拼音",

              duration: 5000,
            });
          }, 0);
          arr2.push("id10");
          arr.push(false);
        }
        if (!this.formData.gj1) {
          setTimeout(() => {
            this.$message({
              showClose: true,
              message: "国籍未选择",

              duration: 5000,
            });
          }, 0);
          arr2.push("id10");
          arr.push(false);
        }
        if (this.formData.gj1 == 2 && !this.$refs.gjt.value) {
          setTimeout(() => {
            this.$message({
              showClose: true,
              message: "请输入国籍",

              duration: 5000,
            });
          }, 0);
          arr2.push("id10");
          arr.push(false);
        }
        if (!this.formData.cxrq) {
          setTimeout(() => {
            this.$message({
              showClose: true,
              message: "请输入出生日期",

              duration: 5000,
            });
          }, 0);
          arr2.push("id10");
          arr.push(false);
        }
        if (!this.$refs.sg.value) {
          setTimeout(() => {
            this.$message({
              showClose: true,
              message: "请输入身高",

              duration: 5000,
            });
          }, 0);
          arr2.push("id10");
          arr.push(false);
        }
        if (!this.$refs.tz.value) {
          setTimeout(() => {
            this.$message({
              showClose: true,
              message: "请输入体重",

              duration: 5000,
            });
          }, 0);
          arr2.push("id10");
          arr.push(false);
        }
        if (!this.$refs.dhhm.value) {
          setTimeout(() => {
            this.$message({
              showClose: true,
              message: "请输入电话号码",

              duration: 5000,
            });
          }, 0);
          arr2.push("id10");
          arr.push(false);
        }
        /*if (!this.$refs.emailt.value) {
          setTimeout(() => {
            this.$message({
              showClose: true,
              message: "请输入E-mail",

              duration: 5000,
            });
          }, 0);
          arr2.push("id10");
          arr.push(false);
        }*/
        if (!this.$refs.xjzd.value) {
          setTimeout(() => {
            this.$message({
              showClose: true,
              message: "请输入现居住地地址",

              duration: 5000,
            });
          }, 0);
          arr2.push("id10");
          arr.push(false);
        }
        if (!this.$refs.ybx.value) {
          setTimeout(() => {
            this.$message({
              showClose: true,
              message: "请输入现居住地地址邮编",

              duration: 5000,
            });
          }, 0);
          arr2.push("id10");
          arr.push(false);
        }
        if (!this.$refs.zlyjdz.value) {
          setTimeout(() => {
            this.$message({
              showClose: true,
              message: "请输入资料邮寄地址",

              duration: 5000,
            });
          }, 0);
          arr2.push("id10");
          arr.push(false);
        }
        if (!this.$refs.ybz.value) {
          setTimeout(() => {
            this.$message({
              showClose: true,
              message: "请输入资料邮寄地址邮编",

              duration: 5000,
            });
          }, 0);
          arr2.push("id10");
          arr.push(false);
        }
        if (!this.$refs.sjr.value) {
          setTimeout(() => {
            this.$message({
              showClose: true,
              message: "请输入收件人",

              duration: 5000,
            });
          }, 0);
          arr2.push("id10");
          arr.push(false);
        }
        if (!this.$refs.sjrdh.value) {
          setTimeout(() => {
            this.$message({
              showClose: true,
              message: "请输入收件人电话",

              duration: 5000,
            });
          }, 0);
          arr2.push("id10");
          arr.push(false);
        }
        if (!this.formData.country) {
          setTimeout(() => {
            this.$message({
              showClose: true,
              message: "母语未选择",

              duration: 5000,
            });
          }, 0);
          arr2.push("id10");
          arr.push(false);
        }
        if (this.formData.country == 2 && !this.$refs.myt.value) {
          setTimeout(() => {
            this.$message({
              showClose: true,
              message: "请输入母语",

              duration: 5000,
            });
          }, 0);
          arr2.push("id10");
          arr.push(false);
        }
        if (this.selectSetMealVal === 0 || this.selectSetMealVal > 0) {
          if (!this.tjxm.length) {
            setTimeout(() => {
              this.$message({
                showClose: true,
                message: "体检套餐未选择",
                duration: 5000,
              });
            }, 0);
            arr2.push("id9");
            arr.push(false);
          }
        }
        if (!this.formData.xwtj1 && !this.xwtj2 && !this.xwtj3) {
          setTimeout(() => {
            this.$message({
              showClose: true,
              message: "请输入希望体检日期",

              duration: 5000,
            });
          }, 0);
          arr2.push("id11");
          arr.push(false);
        }
        if (!this.$refs.jwbsW.checked && !this.$refs.jwbsY.checked) {
          setTimeout(() => {
            this.$message({
              showClose: true,
              message: "既往病史未选择",

              duration: 5000,
            });
          }, 0);
          arr2.push("id12");
          arr.push(false);
        }
        if (this.$refs.jwbsY.checked) {
          if (
            !this.$refs.jwbsC1.checked &&
            !this.$refs.jwbsC2.checked &&
            !this.$refs.jwbsC3.checked &&
            !this.$refs.jwbsC4.checked &&
            !this.$refs.jwbsC5.checked &&
            !this.$refs.jwbsC6.checked
          ) {
            setTimeout(() => {
              this.$message({
                showClose: true,
                message: "既往病史未选择",

                duration: 5000,
              });
            }, 0);
            arr2.push("id12");
            arr.push(false);
          }
          if (this.$refs.jwbsC6.checked && !this.$refs.jwbsCt.value) {
            setTimeout(() => {
              this.$message({
                showClose: true,
                message: "请输入既往病史其它说明",

                duration: 5000,
              });
            }, 0);
            arr2.push("id12");
            arr.push(false);
          }
        }
        if (!this.$refs.gmsW.checked && !this.$refs.gmsY.checked) {
          setTimeout(() => {
            this.$message({
              showClose: true,
              message: "过敏史未选择",

              duration: 5000,
            });
          }, 0);
          arr2.push("id13");
          arr.push(false);
        }
        if (this.$refs.gmsY.checked) {
          if (
            !this.$refs.gmsC1.checked &&
            !this.$refs.gmsC2.checked &&
            !this.$refs.gmsC3.checked
          ) {
            setTimeout(() => {
              this.$message({
                showClose: true,
                message: "过敏史未选择",

                duration: 5000,
              });
            }, 0);
            arr2.push("id13");
            arr.push(false);
          }
          if (this.$refs.gmsC3.checked && !this.$refs.gmsCt.value) {
            setTimeout(() => {
              this.$message({
                showClose: true,
                message: "请输入过敏史其它说明",

                duration: 5000,
              });
            }, 0);
            arr2.push("id13");
            arr.push(false);
          }
        }
        if (!this.$refs.tnjsW.checked && !this.$refs.tnjsY.checked) {
          setTimeout(() => {
            this.$message({
              showClose: true,
              message: "体内有无金属未选择",

              duration: 5000,
            });
          }, 0);
          arr2.push("id14");
          arr.push(false);
        }
        if (this.$refs.tnjsY.checked) {
          if (
            !this.$refs.tnjsC1.checked &&
            !this.$refs.tnjsC2.checked &&
            !this.$refs.tnjsC3.checked &&
            !this.$refs.tnjsC5.checked &&
            !this.$refs.tnjsC5.checked
          ) {
            setTimeout(() => {
              this.$message({
                showClose: true,
                message: "体内有无金属未选择",

                duration: 5000,
              });
            }, 0);
            arr2.push("id14");
            arr.push(false);
          }
          if (this.$refs.tnjsC5.checked && !this.$refs.tnjsCt.value) {
            setTimeout(() => {
              this.$message({
                showClose: true,
                message: "请输入体内有无金属其它说明",

                duration: 5000,
              });
            }, 0);
            arr2.push("id14");
            arr.push(false);
          }
        }
        if (!this.$refs.xyzzW.checked && !this.$refs.xyzzY.checked) {
          setTimeout(() => {
            this.$message({
              showClose: true,
              message: "现有的症状未选择",

              duration: 5000,
            });
          }, 0);
          arr2.push("id15");
          arr.push(false);
        }
        if (this.$refs.xyzzY.checked && !this.$refs.xyzzT.value) {
          setTimeout(() => {
            this.$message({
              showClose: true,
              message: "请输入现有的症状情况",

              duration: 5000,
            });
          }, 0);
          arr2.push("id15");
          arr.push(false);
        }

        if (!this.$refs.xfyywW.checked && !this.$refs.xfyywY.checked) {
          setTimeout(() => {
            this.$message({
              showClose: true,
              message: "现服用的药物未选择",

              duration: 5000,
            });
          }, 0);
          arr2.push("id16");
          arr.push(false);
        }
        if (this.$refs.xfyywY.checked && !this.$refs.xfyywT.value) {
          setTimeout(() => {
            this.$message({
              showClose: true,
              message: "请输入现服用的药物情况",

              duration: 5000,
            });
          }, 0);
          arr2.push("id16");
          arr.push(false);
        }

        if (this.formData.sex == 2) {
          if (!this.$refs.hyknW.checked && !this.$refs.hyknY.checked) {
            setTimeout(() => {
              this.$message({
                showClose: true,
                message: "怀孕的可能性未选择",

                duration: 5000,
              });
            }, 0);
            arr2.push("id17");
            arr.push(false);
          }
          if (!this.$refs.yjqW.checked && !this.$refs.yjqY.checked) {
            setTimeout(() => {
              this.$message({
                showClose: true,
                message: "是否月经期未选择",

                duration: 5000,
              });
            }, 0);
            arr2.push("id17");
            arr.push(false);
          }
        }
        if (
          !this.$refs.lxgs1.checked &&
          !this.$refs.lxgs2.checked &&
          !this.$refs.lxgs3.checked &&
          !this.$refs.lxgs4.checked &&
          !this.$refs.lxgs5.checked &&
          !this.$refs.lxgs6.checked &&
          !this.$refs.lxgs7.checked &&
          !this.$refs.lxgs8.checked &&
          !this.$refs.lxgs9.checked
        ) {
          setTimeout(() => {
            this.$message({
              showClose: true,
              message: "您是如何联系到我公司的未选择",

              duration: 5000,
            });
          }, 0);
          arr2.push("id18");
          arr.push(false);
        }
        if (this.$refs.lxgs7.checked && !this.$refs.lxgs7t.value) {
          setTimeout(() => {
            this.$message({
              showClose: true,
              message: "请输入医院介绍",

              duration: 5000,
            });
          }, 0);
          arr2.push("id18");
          arr.push(false);
        }
        if (this.$refs.lxgs8.checked && !this.$refs.lxgs8t.value) {
          setTimeout(() => {
            this.$message({
              showClose: true,
              message: "请输入医院网站",

              duration: 5000,
            });
          }, 0);
          arr2.push("id18");
          arr.push(false);
        }
        if (this.$refs.lxgs9.checked && !this.$refs.lxgs9t.value) {
          setTimeout(() => {
            this.$message({
              showClose: true,
              message: "请输入其它",

              duration: 5000,
            });
          }, 0);
          arr2.push("id18");
          arr.push(false);
        }
        if (arr2.length) {
          window.scrollTo(
            0,
            document.getElementById(arr2[0]).getBoundingClientRect().top +
            document.documentElement.scrollTop -
            100
          );
        }
        if (arr.length) {
          return false;
        }
        for (let i = 0; i < this.formHtmlOfSet.length; i++) {
          if (this.formHtmlOfSet[i].value) {
            this.formData.selectSetMealVal = i;
          }
        }
        for (let i = 0; i < this.formHtmlOfPro.length; i++) {
          if (this.formHtmlOfPro[i].value) {
            this.formData.selectSetProVal.push(this.formHtmlOfPro[i].name);
          }
        }
        if (this.formData.cxrq) {
          this.formData.cxrq = this.dateFormat(
            "YYYY-mm-dd",
            this.formData.cxrq
          );
        }
        if (this.formData.xwtj1) {
          this.formData.xwtj1 = this.dateFormat(
            "YYYY-mm-dd",
            this.formData.xwtj1
          );
        }
        if (this.formData.xwtj2) {
          this.formData.xwtj2 = this.dateFormat(
            "YYYY-mm-dd",
            this.formData.xwtj2
          );
        }
        if (this.formData.xwtj3) {
          this.formData.xwtj3 = this.dateFormat(
            "YYYY-mm-dd",
            this.formData.xwtj3
          );
        }
        this.formData.tj = this.selectSetMealVal;
        this.formData.tjtcid = this.tjid;
        this.formData.tjxm = this.tjxm;
        try {
          let data = {
            content: this.formData,
            // content: str,
            hospital_id: this.id,
            name: this.formData.formName,
            pinyin: this.formPY,
          };
          let res = await apis.submitFormData(data);
          if (res.code == 200) {
            this.$message({
              showClose: true,
              message: "提交成功！",
              type: "success",
              duration: 5000,
            });
            let form_id = res.data.id;
            localStorage.setItem("form_id", form_id);
            let type = this.type ? this.type : "";
            if (type.indexOf("2") > -1) {
              this.$router.push({ name: "FormOfOne", params: { hid: this.id } });
            } else if (type.indexOf("3") > -1) {
              this.$router.push({ name: "FormOfTwo", params: { hid: this.id } });
            } else if (type.indexOf("4") > -1) {
              this.$router.push({
                name: "FormOfThree",
                params: { hid: this.id },
              });
            } else {
              // this.$router.push({
              //   name: "Upload",
              //   params: { form_id: form_id }
              // });
              localStorage.setItem("formLink", "one");
              this.$router.push({
                path: "/myfile",
              });
            }
          } else {
            setTimeout(() => {
              this.$message({
                showClose: true,
                message: "提交失败！",

                duration: 5000,
              });
            }, 0);
          }
        } catch (e) {
          console.log(e);
        }
      },
    },
    watch: {
      selectSetMealVal(val, oldVal) {
        let dom = document.querySelector(".porject-box");
        let arr = dom.querySelectorAll("input");
        for (let i = 0; i < arr.length; i++) {
          arr[i].checked = false;
        }
        this.formHtmlOfPro = this.formHtmlOfSet[this.selectSetMealVal].project;
      },
    },
  };
</script>
<style lang="less" scoped>
  /*在谷歌下移除input[number]的上下箭头*/
  input[type="number"]::-webkit-outer-spin-button,
  input[type="number"]::-webkit-inner-spin-button {
    -webkit-appearance: none !important;
    margin: 0;
  }
  /*在firefox下移除input[number]的上下箭头*/
  input[type="number"] {
    -moz-appearance: textfield;
  }
  // 联系公司
  #demo .LXcompany {
    margin: 0 30px 35px;
  }
  #demo .LXcompany .LXradio /deep/ .ivu-col .label-with-radio-1 {
    display: flex;
    align-items: center;
  }
  #demo
  .LXcompany
  .LXradio
  /deep/
  .ivu-col
  .label-with-radio-1
  input[type="checkbox"] {
    vertical-align: middle;
  }
  #demo
  .LXcompany
  .LXradio
  /deep/
  .ivu-col
  .label-with-radio-1
  input[type="text"] {
    margin-left: 10px;
  }
  .LXradio {
    margin-bottom: 10px;
  }
  .label-with-radio-1 {
    position: relative;
    display: inline-block;
    font-size: 12px;
    line-height: 40px;
    vertical-align: middle;
    top: -2px;
    margin: 0 10px;
    input[type="checkbox"] {
      position: relative;
      top: 1.5px;
      margin-right: 7px;
    }
  }

  .yes-label {
    margin-top: 10px;
  }
  .ivu-form-item-content {
    input[type="text"] {
      width: 100%;
      height: 42px;
      border: 1px solid #cacaca;
      font-size: 14px;
      color: #000;
      text-indent: 8px;
      outline: none;
    }
  }
  .page-form {
    background: #fff;
    .top-left {
      input {
        width: 326px;
      }
    }
  }
  .page-wrap {
    width: 970px;
    border: 1px solid #dcdcdc;
    margin: 0 auto 30px;
  }
  .page-head {
    height: 80px;
    background: #ae1e10;
    color: #fff;
    text-align: center;
    h3 {
      font-size: 30px;
      line-height: 50px;
    }
    p {
      font-size: 18px;
    }
  }
  .page-body {
    background: #fff;
    margin: 0 33px;

    .row-m {
      margin-top: 30px;
    }

    .page-menu {
      width: 100%;
      display: table;
      // height: 299px;
      border: 1px solid #e3e3e3;
      margin-bottom: 30px;

      .page-submenu {
        width: 290px;
        float: left;
        height: 100%;
        border-right: 1px solid #e3e3e3;

        .pageMenu-li {
          width: 100%;
          height: calc(200px / 4);
          border-bottom: 1px solid #e3e3e3;
          padding-top: 15px;
          padding-left: 20px;
          &:last-child {
            border-bottom: none;
          }
          .pageMenu-span {
            font-size: 16px;
            font-weight: bold;
            padding-left: 15px;
          }
        }
      }
      .porject-box {
        float: left;
        width: 606px;
        padding: 10px 20px;
        margin-left: -1px;
        border-left: 1px solid #e3e3e3;
        li {
          display: inline-block;
          margin: 5px;
          span {
            margin-left: 10px;
            line-height: 30px;
            font-size: 14px;
          }
        }
      }
    }
  }
  .page-line {
    margin-bottom: 24px;
  }
  .page-row {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    // margin: 0 30px;
  }
  .page-column {
    width: 50%;
    padding-left: 30px;
  }
  .page-cross {
    border-bottom: 1px dashed #e2e2e2;
    padding: 30px 0;
  }
  .page-border {
    border-bottom: 1px dashed #e2e2e2;
  }
  .flex {
    width: 100%;
    // flex: 1;
  }
  .form-cell {
    // flex: 1;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    margin: 15px 30px;
    label.form-label {
    }
    label.label-radio {
      display: inline-block;
      width: 80px;
      font-size: 18px;
      color: #000;
      line-height: 40px;
    }
  }
  .form-in-input {
    height: 42px;
    border: 1px solid #cacaca;
    font-size: 14px;
    color: #000;
    text-indent: 8px;
    outline: none;
  }
  .form-input {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;

    input[type="text"] {
      // flex: 1;
      height: 40px;
      border: 1px solid #cacaca;
      font-size: 18px;
      color: #000;
      text-indent: 8px;
      outline: none;
    }
  }
  .abc {
    &::after {
      display: inline-block;
      content: "■";
      color: #ae1e10;
      font-size: 18px;
      margin-left: 10px;
      vertical-align: middle;
    }
  }
  .page-note {
    &:before {
      display: inline-block;
      content: "■";
      color: #ae1e10;
      font-size: 18px;
      margin-right: 10px;
      vertical-align: middle;
    }
    margin: 0 0 18px;
    span {
      font-size: 14px;
      color: #999999;
      line-height: 30px;
      vertical-align: middle;
    }
    i {
      color: #ae1e10;
    }
  }

  .page-title {
    position: relative;
    height: 60px;
    font-size: 22px;
    color: #000;
    line-height: 60px;
    background: #f5f4f4;
    padding-left: 36px;
    margin-bottom: 30px;
    font-weight: bold;
    i {
      color: #ae1e10;
    }
    &:before {
      position: absolute;
      left: 0;
      top: 0;
      content: "";
      display: block;
      width: 10px;
      height: 60px;
      background: #ae1e10;
    }
  }
  .page-stitle {
    font-size: 18px;
    color: #000;
    margin: 30px 0 18px 0 !important;
  }
  .page-text {
    width: 100%;
    min-height: 130px;
    font-size: 16px;
    color: #000;
    line-height: 24px;
    border: 1px solid #bababa;
    outline: none;
    resize: none;
    padding: 10px;
  }
  .page-state {
    font-size: 14px;
    color: #000;
    line-height: 30px;
  }
  .btn {
    width: 200px;
    height: 50px;
    background: #ac4126;
    color: #fff;
    font-size: 20px;
    line-height: 40px;
    text-align: center;
    border: none;
    border-radius: 4px;
    margin-bottom: 50px;
  }

  ::-webkit-input-placeholder {
    color: #dcdcdc;
    font-size: 16px;
  }

  .ivu-col .ivu-form-item-label {
    font-size: 18px;
  }

  .page-hope {
    .first-icon {
      position: relative;
    }

    .span-icon {
      position: absolute;
      left: 12px;
      top: 10px;
      display: block;
      width: 20px;
      height: 20px;
      border-radius: 50%;
      background-color: #e9e9e9;
      text-align: center;
      line-height: 20px;
    }
  }
  .khxxNameipt2 {
    margin: 0 20px;
    width: 243px !important;
  }
  .khxxNameipt3 {
    width: 310px !important;
  }

  .label-with-radio {
    display: inline-block;
    font-size: 14px;
    line-height: 14px;
    vertical-align: middle;
    margin: 10px 10px;
  }

  .no-label {
    margin-bottom: 2px !important;
    display: flex !important;
    align-items: center;
    padding: 15px 0;
  }

  .ivu-col-span-3 {
    display: block !important;
    width: 12.5% !important;
  }
  ::v-deep .shengao1 .ivu-form-item-label {
    padding-left: 20px !important;
    text-align: right !important;
  }
  .ivu-diy-input {
    height: 42px;
    border: 1px solid #cacaca;
    font-size: 14px;
    color: #000;
    text-indent: 8px;
    outline: none;
  }
</style>